import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const notSelect = css`
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
`;

export const showHeaderCSS = css`
  h1 {
    font-size: 2em !important;
    * {
      font-size: 1em !important;
    }
  }
  h2 {
    font-size: 1.5em !important;
    * {
      font-size: 1em !important;
    }
  }
  h3 {
    font-size: 1.15em !important;
    * {
      font-size: 1em !important;
    }
  }
`;

export const notDraggable = css`
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

export const CenterCSS = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Center = styled.div`
  ${CenterCSS}
`;

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const Ellipsis = css`
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
`;

export const customTooltip = css`
  opacity: 1 !important;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px !important;
  padding: 8px 12px !important;
  ${notSelect}
`;
